export const WHATSAPP_URL = 'https://wa.me/message/LI4MMCWOOCMYN1'

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/xnYuVfeeHM22t2fgtZKw2A/ChatGPT_Image_27_ago_2026,_07_02_14_p.m..png'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/d92adc6e-6182-4487-8c9a-bce8a93441ca.jpg'

export const GUIDE_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/1aada3f2-37c9-4288-a269-e12df52aece7.jpg'

export const CARELIZ_PORTRAIT =
  'https://cdn.magicpatterns.com/uploads/4mHtuDrxWieW93U2djMZwE/e61b41a4-3b66-4fa3-8466-b47c20d89930_4.jpg'

/** VSL — cambia solo este id si subes otro video */
export const VSL_YOUTUBE_ID = 'vmB7S93QfoY'

/** Precio de La Herradura Dorada — edítalo aquí */
export const PRICE = 'USD 97'
